import { StrictRouteConfig } from "@/router/router";

export const floorplanRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/offices/:officeId/floorplan",
        name: "floorplan",
        component: () => import(/* webpackChunkName: "floorplan" */ "@/views/floorplan/floorplan.vue"),
        meta: {
            requiresAuth: true,
            label: "Floorplan",
            title: "Floorplan",
            includeInSubNavigation: true,
            icon: "map-outline",
            matchExact: false,
            path: ["dashboard", "offices", "office", "floorplan"],
            order: 30,
        },
    },
];
